import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"
import Loader from "react-loader-spinner";

class AlunosAdmin extends Component {

  state = {
    alunos:[],
    search:null,
    loaded:false
  }



  async componentDidMount(){
 
    this.loadalunos(null);
  }

  async loadalunos(search_val){
    this.setState({
      alunos:[],
      loaded:false
    })
    let search;
    if(search_val==null){
      search = this.state.search;
    }else{
      search =search_val;
    }
    const response = await api.post("/admin/users", {search});

    if(response.data){
      this.setState({
        alunos:response.data.success,
        loaded:true
      })
    }
    
  }

  async shouldComponentUpdate(nextProps, nextState){

    if(this.state.search!==nextState.search){
      const {search} = nextState;
      this.loadalunos(search);

      this.forceUpdate();
    }

    return true;
  }



  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-10 p-4">     

        <h4>Lista de Alunos</h4>     





    {/* Tables */}
    <input type="text" id="myInput" onChange={e => this.setState({ search: e.target.value })} placeholder="Nome Aluno ou CPF" />
    <button type="button" class="btn btn-light btn-sm">Pesquisar</button>

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
    <th class="th-sm">ID

</th>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">E-mail

      </th>
      <th class="th-sm">CPF

      </th>
      <th class="th-sm">Telefone

      </th>
      <th class="th-sm">Ação

      </th>

    </tr>
  </thead>
  <tbody>
  {this.state.alunos.map(el => (
    <tr>
      <td>{el.user.id}</td>
      <td>{el.nomecompleto}</td>
      <td>{el.user.email}</td>
      <td>{el.cpf}</td>
      <td>{el.telefone1}</td>
      <td>
          <a href={"/admin/alunos/edit/"+el.user.id} class="btn btn-secondary btn-sm">Editar</a>
          <a href={"/admin/alunos/pass/"+el.user.id} class="btn btn-info btn-sm">Alterar Senha</a>
          <a href={"/admin/alunos/remove/"+el.user.id} class="btn btn-danger btn-sm">Remover</a>
      </td>
    </tr>
  ))}

    
    
   
    
  </tbody>

</table>
<Loader
    className="d-flex justify-content-center"
    type="TailSpin"
    color="#00BFFF"
    height={100}
    width={100}
    visible={this.state.loaded==false} //3 secs
    />

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(AlunosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/alunos.js